import auth from './auth';
import registration from './registration';

export default {
  auth,
  registration
}